var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" História výpočtov ")]), _c('button', {
    staticClass: "w-button",
    on: {
      "click": function click($event) {
        return _vm.loadCalculation();
      }
    }
  }, [_vm._v("Načítať")])]), _vm._l(_vm.history, function (calculation, key) {
    return _c('div', {
      key: key,
      staticClass: "div-block-141 pointer noselect",
      staticStyle: {
        "margin-bottom": "5px",
        "position": "relative"
      },
      on: {
        "click": function click($event) {
          if ($event.target !== $event.currentTarget) return null;
          return _vm.pickCalculation(calculation, key);
        }
      }
    }, [_c('div', [_c('strong', [_vm._v(" [ " + _vm._s(_vm._f("dotTheAmount")(calculation.suma_bezucel + calculation.suma_nadobudnutie + calculation.suma_refinancovanie)) + " EUR ")]), _vm._v(", FIX " + _vm._s(calculation.fix) + " "), _c('strong', [_vm._v("]")]), _vm._v(" zo dňa " + _vm._s(_vm.getDate(calculation.date)) + "." + _vm._s(_vm.getMonth(calculation.date)) + "." + _vm._s(_vm.getYear(calculation.date)) + " o " + _vm._s(_vm.getHours(calculation.date)) + ":" + _vm._s(_vm.getMinutes(calculation.date)) + " "), calculation.client ? _c('div', {
      staticClass: "text-color-disabled pop-500",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(" KLIENTOV VÝPOČET ")]) : _c('div', {
      staticClass: "bl-color pop-500",
      staticStyle: {
        "font-size": "12px"
      },
      on: {
        "click": function click($event) {
          if ($event.target !== $event.currentTarget) return null;
          return _vm.pickCalculation(calculation, key);
        }
      }
    }, [!calculation.sent ? _c('span', {
      on: {
        "click": function click($event) {
          return _vm.sendOffer(calculation, key);
        }
      }
    }, [_vm._v(" ODOSLAŤ NÁVRH ")]) : _c('span', {
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v(" UŽ ODOSLANÉ ")])])]), _vm.pickedKey === key ? _c('img', {
      staticClass: "nav-link-icon filter-primary",
      staticStyle: {
        "position": "absolute",
        "right": "20px"
      },
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f25_icons8-check.svg",
        "alt": ""
      }
    }) : _vm._e()]);
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }